<template>
  <div class="main">
    <Sidebar
      :current-keywords="keywords"
      :current-filters="currentFilters"
      :filter-types="filterTypes"
      @search="setKeywords"
      @add-filter="addFilter"
      @remove-filter="removeFilter"
      @remove-all-filters="removeAllFilters"
    />

    <div class="title-bar">
      <a class="float-right btn btn-secondary" :href="route('admin.categories.create')">
        <span class="icon icon-plus"></span>
        <span class="text">Add New</span>
      </a>
      <h1>Categories</h1>
      <AdminMenu class="pt-2" current="System" />
    </div>

    <div class="content p-3">
      <div class="row">
        <div class="col-12">
          <transition name="fade">
            <Alert v-if="hasAlert" :alert="alert" />
          </transition>
          <div class="row">
            <div class="col-12">
              <ListTable
                :items="items"
                :columns="columns"
                :activeColumns="activeColumns"
                :hideNoResults="hideNoResults"
                @sort-by="setSort"
                @swap-column="setActiveColumn"
                @item-clicked="setSelectedItem"
              >
                <template v-slot:col_is_active="{ item }">{{ !!item.is_active ? "Yes" : "No" }}</template>
                <template v-slot:col_is_toggle="{ item }">{{ !!item.toggle ? "Yes" : "No" }}</template>
                <template v-slot:list-menu="{ item, id }">
                  <CategoryListMenu :item="item" :id="id" :eventBus="listEvents" />
                </template>
              </ListTable>
            </div>
          </div>
          <div class="row">
            <div class="d-none d-xl-flex col-xl-3"></div>
            <div class="col-12 col-xl-6 text-center">
              <Pagination
                class="d-inline-block"
                :total="totalPages"
                :value="parseInt(pagination.current)"
                @input="setCurrentPage"
              />
            </div>
            <div class="col-12 col-xl-3 text-center text-xl-right">
              <PageSize :value="parseInt(pagination.per_page)" @input="setPerPage" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";
import ListingMixin from "mixins/Listing";
import AdminMenu from "../partials/AdminMenu";
import CategoryListMenu from "./partials/ListMenu";

export default {
  mixins: [DisplaysAlerts, ListingMixin],
  components: {
    AdminMenu,
    CategoryListMenu
  },
  methods: {
    activate(item) {
      this.axios
        .post(this.route("admin.categories.activate", { category: item.id }))
        .then(() => {
          this.showAlert(
            "success",
            `The "${item.name}" category has been ACTIVATED.`,
            true
          );
          this.refresh();
        })
        .catch(() => {});
    },
    deactivate(item) {
      this.axios
        .post(this.route("admin.categories.deactivate", { category: item.id }))
        .then(() => {
          this.showAlert(
            "success",
            `The "${item.name}" category has been DE-ACTIVATED.`,
            true
          );
          this.refresh();
        })
        .catch(() => {});
    },
    handleMenuAction(action, item) {
      if (action == "activate") {
        this.activate(item);
      } else if (action == "deactivate") {
        this.deactivate(item);
      }
    }
  },
  mounted() {
    this.listEvents.$on("menu-action", this.handleMenuAction);
  }
};
</script>
